import {
  PullToRefresh as SharedPullToRefresh,
  type PullToRefreshProps as SharedPullToRefreshProps,
} from '@/components/pull-to-refresh'

type Props = Omit<
  SharedPullToRefreshProps,
  'testId' | 'pullLabelKey' | 'releaseLabelKey' | 'refreshingLabelKey'
>

export function PullToRefresh(props: Props) {
  return (
    <SharedPullToRefresh
      {...props}
      testId="profile-social-pull-to-refresh"
      pullLabelKey="profileSocial.refresh.pull"
      releaseLabelKey="profileSocial.refresh.release"
      refreshingLabelKey="profileSocial.refresh.refreshing"
    />
  )
}
